<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-04-23 09:39:29
 * @LastEditors: yangxiaofeng
 * @LastEditTime: 2024-03-11 17:22:12
-->
<template>
  <div class="accessFailed">
    <div class="imgBox">
      <img class="img" src="@/assets/images/404.png" alt="" />
      <p class="msg">{{msg}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accessFailed',
  data() {
    return {
      msg: this.$route.query.msg
    };
  },
};
</script>
<style scoped>
.accessFailed {
  widows: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.msg{
  margin: 0 20px;
  word-break: break-all;
}
.img{
  margin-bottom: 16px;
}
.imgBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4.5rem;
}
.imgBox p {
  font-size: 16px;
  color: #999;
}
.imgBox img {
  width: 45%;
}
</style>
